<div class="">
  <a (click)="upgradePlan()" *ngIf="isOwner">Upgrade Plan</a> 
  <span *ngIf="!isOwner">Upgrade Plan</span>
  to unlock full e-Invoice functions, including advanced controls and personalized settings!
</div>